import { HttpStatusCodes } from '@absg/angular-common';
import { ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, Observable, throwError, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export const genericRetryStrategy = ({
  retryCount = new BehaviorSubject<number>(0),
  changeDetectionRef = null,
  maxRetryAttempts = 5,
  scalingDuration = 2000,
  excludedStatusCodes = [HttpStatusCodes.BAD_REQUEST, HttpStatusCodes.NO_CONTENT],
}: {
  retryCount?: BehaviorSubject<number>,
  changeDetectionRef?: ChangeDetectorRef,
  maxRetryAttempts?: number,
  scalingDuration?: number,
  excludedStatusCodes?: number[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} = {}) => (attempts: Observable<any>) => attempts.pipe(
  mergeMap((error, i) => {
    const retryAttempt = i + 1;
    if (
      retryAttempt > maxRetryAttempts ||
      excludedStatusCodes.find(e => e === error.status)
    ) {
      return throwError(error);
    }
    if (changeDetectionRef) {
      retryCount.next(retryAttempt);
      changeDetectionRef.markForCheck();
    }
    return timer(retryAttempt * scalingDuration);
  }),
);
